import React  from 'react';
import TouchAppIcon from '@mui/icons-material/TouchApp';
//import { useRecoilValue_TRANSITION_SUPPORT_UNSTABLE } from "recoil";
import ButtonCustom from "./ButtonCustom";
import { yellowButton } from "src/shared/styles/buttonStyles";
//import { showModalEditFiltersState } from 'src/store/reservation/reservationState';
//import { historyRouteState } from 'src/store/global/historyState';
import { useNavigate } from 'react-router-dom' ;
const ScheduleTimeButtom = () => {
    //const setShowModalEditFilters = useSetRecoilState(showModalEditFiltersState);
    //const historyRoute = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(historyRouteState);
    const navigate = useNavigate();

    const handleClickButton = () => {
        //historyRoute.push(process.env.REACT_APP_ROOT_SERVER_PATH);
        navigate(process.env.REACT_APP_ROOT_SERVER_PATH);

        //setShowModalEditFilters(true)
    }

    return (
        <ButtonCustom
            onClick={handleClickButton}
            style={{ ...yellowButton }}
            text="Buscar Hora"
            icon={<TouchAppIcon />}
        ></ButtonCustom>
    )
}

export default ScheduleTimeButtom
